import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
// import { TransitionMotion, Motion, spring, presets } from 'react-motion';
import { connect } from 'react-redux'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AddIcon from "../icon/AddIcon";
import EditIcon from "../icon/EditIcon";
import HamburgerIcon from "../icon/HamburgerIcon";
import EnterIcon from "../icon/EnterIcon";
import RemoveIcon from "../icon/RemoveIcon";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import CrossIcon from '../icon/Cross'
import {TourInfoProposalItems} from './dev/TourInfoData';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};
const { REACT_APP_URI = '/' } = process.env

class InfoProposal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isActive: null,
			// items: [],
			items: [],
			addInputValue: "",
			editInput: "",
			creatorTitle: this.props.creatorTitle,
			infoId: this.props.infoId,
		};
		this.onDragEnd = this.onDragEnd.bind(this);
	}
	componentDidMount = () => {
		this.getProposal()
	};
	getProposal = () => {
		// this.setState({ listLength: this.state.mine.length, mineIsLoading: true }))
		// if(this.props.user.plan === 'Brand' || this.props.user.plan === 'Agency') {
			fetch(`${REACT_APP_URI}/getMyProposalsInInfoId/`, { credentials: 'include' })
			.then(res => {
				if (res.ok) return res.json()
				else throw res
			})
			.then(items => {
				items = items.map(i => { 
					const isThisCreatorInItem = i.channels.includes(this.state.creatorTitle);
					return { ...i, isEdit: false, isDelete: null, show: true, isTitleEdit: false, isThisCreatorInItem: isThisCreatorInItem, editedTitle: i.title, } 
				})
				this.setState({ items })
			})
		// }
	}
	toggleActive = () => {
		let { isActive } = this.state
		if (isActive === null) {
			this.setState({ isActive: true })
		}
		else this.setState({ isActive: !isActive })
	}
	addItemInput = e => this.setState({ addInputValue: e.target.value });
	addItemSubmit = () => {
		const { props: { messages, user: { token } }, state: { addInputValue }, getProposal, } = this
		if(addInputValue === '') return // 不允許空白提案
		fetch(`${REACT_APP_URI}/api/Proposal/`, {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				"X-CSRFToken": token,
			},
			body: JSON.stringify({
				title: addInputValue,
				channels: null,
			})
		})
			.then(res => {
				const { status } = res
				if (status === 200) {
					getProposal();
					this.setState({ addInputValue: '' })
				}
				else console.log(messages.payment_unknown_error)
			})
	};
	// toggleEdit = (editTitle, isEdit) => new Promise(resolve => {
	// 	let items = this.state.items.map(item => {
	// 		if (item.title === editTitle) {
	// 			return { ...item, isEdit: isEdit, isDelete: null };
	// 		}
	// 		return item;
	// 	});
	// 	this.setState(
	// 		{ items, editTitle },
	// 		resolve
	// 	);
	// });
	toggleTitleEdit = index => {
		let { items } = this.state
		let { isEdit } = items[index]
		items.splice(index, 1, { ...items[index], isEdit: !isEdit })
		this.setState({ items })
	}
	editTitleInput = index => e => {
		let { items } = this.state
		items.splice(index, 1, { ...items[index], editedTitle: e.target.value })
		this.setState({ items })
	}
	editTitleSubmit = (index) => {
		const { messages, user: { token } } = this.props
		const { getProposal } = this
		const { id, editedTitle } = this.state.items[index]
		fetch(`${REACT_APP_URI}/api/Proposal/${id}/`, {
			method: 'put',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				"X-CSRFToken": token,
			},
			body: JSON.stringify({
				title: editedTitle,
				channels: null,
			})
		})
			.then(res => {
				const { status } = res
				if (status === 200) getProposal('mine')
				else console.log(messages.payment_unknown_error)
			})
	}
	toggleDelete = (index, isDelete) => {
		let { items } = this.state
		items.splice(index, 1, { ...items[index], isDelete: isDelete })
		this.setState({ items })
	}
	deleteSubmit = id => {
		const { props: { messages, user: { token } }, getProposal } = this
		fetch(`${REACT_APP_URI}/api/Proposal/${id}`, {
			method: 'delete',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				"X-CSRFToken": token,
			},
		})
			.then(res => {
				const { status } = res
				if (status === 200) {
					getProposal();
				}
				else console.log(messages.payment_unknown_error)
			})
	}
	toggleCreator = (id, isThisCreatorInItem) => {
		const { infoId } = this.state
		const creatorAddOrRemove = isThisCreatorInItem ? 'removeChannelFromProposal' : 'addChannelToProposalWithInfoId';
		const { props: { messages, user: { token } }, getProposal, } = this
		fetch(`${REACT_APP_URI}/${creatorAddOrRemove}/${id}`, {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				"X-CSRFToken": token,
			},
			body: JSON.stringify({
				id: infoId,
			})
		})
			.then(res => {
				const { status } = res
				if (status === 200) {
					getProposal();
				}
				else console.log(messages.payment_unknown_error)
			})
	}
	toggleCreatorsList = (itemId, toggle) => () => {
		let items = [...this.state.items];
		items = items.map(item => {
			if (item.id === itemId) {
				return { ...item, channelsListActicve: toggle };
			}
			return item;
		});
		this.setState({ items });
	};
	// drag邏輯
	onDragEnd(result) {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const items = reorder(
			this.state.items,
			result.source.index,
			result.destination.index
		);

		this.setState({ items });
	}
	renderItem = (item, index) => {
	}
	render() {
		const {
			toggleActive, addItemInput, addItemSubmit,
			toggleTitleEdit, editTitleInput, editTitleSubmit,
			// onDeleteStart, onDeleteCancel, onDeleteConfim,
			toggleDelete, deleteSubmit,
			toggleCreator, toggleCreatorsList
		} = this
		let { isActive, addInputValue, items } = this.state
		const { messages, messages: { localeLanguage}, tour:{ isInfoTourActive} } = this.props
		const inActiveProposalWidth = messages.localeLanguage === 'zh' ? '100px' : localeLanguage === "es" ? '200px' : localeLanguage === "jp" ? '180px' : '130px';
		if(isInfoTourActive) items = TourInfoProposalItems
		return (
			<ProposalWrap 
				id="user_tour_info_8"
				isActive={isInfoTourActive ? true : isActive} 
				inActiveProposalWidth={inActiveProposalWidth}>
				<ProposalTitle 
					onClick={toggleActive} 
					isActive={isInfoTourActive ? true : isActive} 
					inActiveProposalWidth={inActiveProposalWidth}>
					<div>{messages.info_add_proposal}</div>
				</ProposalTitle>
				<ProposalBottomPart 
					isActive={isInfoTourActive ? true : isActive} 
					>
					<ItemAddWrap>
						<ItemAdd
							onChange={addItemInput}
							onKeyPress={e => e.key === "Enter" && addItemSubmit()}
							value={addInputValue} type="text" placeholder={messages.info_new_proposal_name}
						/>
						<IconWrap onClick={addItemSubmit}>
							<EnterIcon />
						</IconWrap>
					</ItemAddWrap>
					{items.length === 0 &&
						<NoneItem>
							{messages.info_no_proposal}
            			</NoneItem>
					}
					<DragDropContext onDragEnd={this.onDragEnd}>
						<Droppable droppableId="droppable">
							{(provided, snapshot) =>
								<ListWrap>
									<List innerRef={provided.innerRef} isDraggingOver={snapshot.isDraggingOver}>
										<TransitionGroup className="proposal">
											{items.map((item, index) => (
												<CSSTransition
													key={item.id}
													timeout={200}
													classNames="fade"
												>
													<Draggable draggableId={item.id} index={index}>
														{(provided, snapshot) => (
															<Wrap>
																<Items
																	innerRef={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																	isDragging={snapshot.isDragging}
																	style={{
																		...provided.draggableProps.style
																	}}
																	isEdit={item.isEdit}
																>
																	{!item.isEdit &&
																		<ItemWrap isDragging={snapshot.isDragging}>
																			<IconWrap>
																				<HamburgerIcon />
																			</IconWrap>
																			<ItemContentWrap>
																				<ItemContent isDragging={snapshot.isDragging}>
																					{item.title}
																				</ItemContent>
																				<CreatorsWrap>
																					<CreatorCountsWrap
																						onMouseEnter={toggleCreatorsList(item.id, true)}
																						onMouseLeave={toggleCreatorsList(item.id, false)}
																						isDragging={snapshot.isDragging}
																					>
																						<CreatorCounts isDragging={snapshot.isDragging}>
																							{item.channels.length}
																						</CreatorCounts>
																					</CreatorCountsWrap>
																					{item.channelsListActicve && item.channels.length > 0 &&
																						<CreatorsList
																							onMouseEnter={toggleCreatorsList(item.id, true)}
																							onMouseLeave={toggleCreatorsList(item.id, false)}
																						>
																							{item.channels.map(creator => (
																								<Creators>{creator}</Creators>
																							))}
																						</CreatorsList>
																					}
																				</CreatorsWrap>
																			</ItemContentWrap>
																			<IconPosition>
																				<IconWrap
																					onClick={() =>toggleTitleEdit(index)}
																					htmlFor={item.id}
																				>
																					<EditIcon />
																				</IconWrap>
																			<IconWrap 
																				id="user_tour_info_9"
																				onClick={() => toggleCreator(item.id, item.isThisCreatorInItem)}>
																					{item.isThisCreatorInItem && <RemoveIcon />}
																					{!item.isThisCreatorInItem && <AddIcon/>}
																				</IconWrap>
																			</IconPosition>
																		</ItemWrap>
																	}
																	{item.isEdit &&
																		<ItemWrap isEdit={item.isEdit}>
																			{(item.isDelete === null ||
																				item.isDelete === false) && [
																					<ItemDelete isDelete={item.isDelete} onClick={() => toggleDelete(index, true)}>
																						<span onClick={() => toggleDelete(index, true)}>
																							<CrossIcon color='#fff' width='100%'/>
																						</span>
																					</ItemDelete>,
																					<ItemEditContent
																						id={"child" + item.id}
																						defaultValue={item.title}
																						autoFocus={true}
																						onChange={editTitleInput(index)}
																						onKeyPress={e => e.key === "Enter" && editTitleSubmit(index)}
																						isDragging={snapshot.isDragging}
																					/>,
																					<ItemEditCancel onClick={() => toggleTitleEdit(index)}>
																						{messages.cancel}
																					</ItemEditCancel>
																				]}
																			{item.isDelete &&
																				<ItemDelete isDelete={item.isDelete}>
																				<ItemDeleteCheckWrap isDelete={item.isDelete} localeLanguage={localeLanguage}>
																						<span>{messages.info_confirm_delete}</span>
																					<ItemDeleteCheck localeLanguage={localeLanguage}>
																							<ItemDeleteCheckButton onClick={() => deleteSubmit(item.id)}>
																								{messages.ok}
																							</ItemDeleteCheckButton>
																							<ItemDeleteCheckButton onClick={() => toggleDelete(index, false)}>
																								{messages.cancel}
																							</ItemDeleteCheckButton>
																						</ItemDeleteCheck>
																					</ItemDeleteCheckWrap>
																				</ItemDelete>
																			}
																		</ItemWrap>
																	}
																</Items>
															</Wrap>
														)}
													</Draggable>
												</CSSTransition>
											))}
										</TransitionGroup>
									</List>
								</ListWrap>}
						</Droppable>
					</DragDropContext>
				</ProposalBottomPart>
			</ProposalWrap>
		)
	}
}
const mapStateToProps = state => {
	return {
		user: state.User,
		messages: state.Messages,
		tour: state.Tour,
	}
}
const AnimationdeleteStart = keyframes`
    0% {
        width: 20px;
        color: transparent;
        background-color: #666666;
    }
    1% {
        background-color: #A0A0A0;   
        
    }
	100% {
        color: #fafafa;
        width: 250px;
        background-color: #A0A0A0;   
    }
`;
const AnimationdeleteCancel = keyframes`
	  0% {
        color: transparent;
        width: 250px;   
        background-color: #A0A0A0;
    }
    50% {
        background-color: #A0A0A0;
    }
    99% {
        color: transparent;       
        background-color: #666666;      
    }
    100% {
        width: 20px;
        color: #fafafa;
        background-color: #666666;
	}
`;
const ProposalBottomOpen = keyframes`
  0% {
    max-height: 0px
  }
  100% {
    max-height: 240px;
  }
`
const ProposalBottomClose = keyframes`
  0% {
    max-height: 240px;
  }
  100% {
    max-height: 0px
  }
`
const ProposalWrap = styled.div`
  position: absolute;
  right: 0;
  width: ${props => props.isActive ? "250px" : `${props.inActiveProposalWidth}`};  
  /* width: ${props => props.isActive ? "250px" : '100px'};   */
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  transition: all .5s ease;
`;//踩雷：beautiful-dnd父元素設定transform-translate的話判定點會偏移導致bug產生

const ProposalTitle = styled.div`
  height: 40px;
  padding: 10px 10px;
  background-color: #e94242;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  border-radius: ${({isActive}) => isActive ? '5px 5px 0 0' : '5px'};
  cursor: pointer;
  div {
	text-align: center;
	width: ${props => `calc(${props.inActiveProposalWidth} - 20px)`};
  }
`;
const ProposalBottomPart = styled.div`
  max-height: ${props => (props.isActive ? "240px" : "0")};
  animation: ${props => props.isActive ? `${ProposalBottomOpen} .5s ease` : props.isActive === false ? `${ProposalBottomClose} .5s ease` : ''};  
  overflow: hidden;
`;
const ItemAddWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 250px; */
  width: 100%;
  height: 40px;
  padding: 8px 10px 8px 20px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #787878;
`;
const ItemAdd = styled.input`
  width: 170px;
  padding-left: 8px;
  border: 1px solid #dedede;
  background-color: transparent;
  &:focus {
    border: 3px solid rgba(222, 6, 6, 0.2);
    padding-left: 6px;
    outline: none;
  }
`;
const NoneItem = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 24px; 
  font-size: 10px;
  font-weight: 300;
  color: #d8d8d8;
`
const ListWrap = styled.div`
  max-height: 200px;
  overflow-y: scroll;
`;
const List = styled.div`
    background: ${props =>
		props.isDraggingOver ? "rgba(222, 6, 6, 0.2)" : "transparent"};
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`;
const Wrap = styled.div``;
const Items = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  height: 40px;
  padding: ${props => (props.isEdit ? "0" : "0 10px")};
  border-bottom: 1px solid #e6e6e6;
  color: ${props => (props.isDragging ? "#fff" : "#787878")};
  font-size: 12px;
  font-weight: 300;
  background: ${props => (props.isDragging ? "#E94242" : "#fff")};
  &:focus {
    outline: none;
  } /*拖拉不要外誆線,非border*/
`;

const ItemWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: ${props => (props.isEdit ? "0 0 0 30px" : "")};
  svg {
    path {
      fill: ${props => (props.isDragging ? "#fff" : "")};
    }
  }
`;
const ItemContentWrap = styled.div`
  display: flex;
  align-items: center;
  width: 160px;
`;
const ItemContent = styled.div`
  display: inline-flex;
  border: 1px solid transparent;
  color: ${props => (props.isDragging ? "#ffffff" : "#787878")};
  font-size: 12px;
  font-weight: 300;
`;
const CreatorsWrap = styled.div`
  position: relative;
`;
const CreatorCountsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 3px;
  color: #787878;
  z-index: 500;
  cursor: pointer;
`;
const CreatorCounts = styled.div`
  color: ${props => props.isDragging ? '#fff' : '#e94242'};
  font-size: 10px;
  font-weight: 500;
  &:before {
    content: '(';
    color: ${props => props.isDragging ? '#fff' : '#787878'};
  }
  &:after {
    content: ')';
    color: ${props => props.isDragging ? '#fff' : '#787878'};
  }
`;
const CreatorsList = styled.div`
  position: absolute;
  width: 150px;
  height: auto;
  left: -80px;
  top: 20px;
  background-color: #fff;
  border: 1px solid #999999;
  z-index: 1000;
`;
const Creators = styled.div`
  display: inline-flex;
  align-items: center;
  height: auto;
  padding: 0 7px;
  font-size: 12px;
  font-weight: 300;
`;
const ItemEditContent = styled.input`
  width: 160px;
  padding-left: 4px;
  border: 1px solid #dedede;
  outline: none;
  color: ${props => (props.isDragging ? "#fff" : "#787878")};
  font-size: 12px;
  font-weight: 300;
  background-color: transparent;
`
const ItemEditCancel = styled.div`
  display: flex;
  align-items: center;
	justify-content: center;
  width: 60px;
  background-color: #fff;
  color: #787878;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    font-weight: 600;
    text-decoration: underline;
  }
`;
const IconPosition = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 30px;
`//讓提案清單展開時icon不要擠一起
const IconWrap = styled.label`
  width: auto;
  cursor: pointer;
  &:hover > svg {
    path,
    polygon {
      fill: #de0606;
    }
  }
`;
const ItemDelete = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  text-align: center;
  width: ${props => (props.isDelete ? "100%" : "20px")};
  height: 40px;
  transform: translateX(-30px);
  background-color: ${props => (props.isDelete ? "#A0A0A0" : "#666666")};
  color: #fafafa;
  font-weight: 300;
  cursor: ${props => (props.isDelete ? "" : "pointer")};
  animation: ${props =>
		props.isDelete === true
			? `${AnimationdeleteStart} .3s ease-in-out`
			: props.isDelete === false
				? `${AnimationdeleteCancel} .3s ease-in-out`
				: ""};
  transition: width 5s ease;
  &:hover {
    background-color: ${props => (props.isDelete ? "" : "#A0A0A0")};
  }
`
const ItemDeleteCheckWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 0 0 0 34px;
  color: #fafafa;
  font-weight: 300;
  white-space: nowrap;
	${({ localeLanguage }) => localeLanguage !== 'zh' ? 'flex-direction: column; padding: 0;' : ''};
  span:nth-child(1) {
    padding-right: 26px;
		${({ localeLanguage }) => localeLanguage !== 'zh' ? 'padding-right: 0' : ''};
  }
`
const ItemDeleteCheck = styled.div`
		display: flex;
    align-items: center;
`
const ItemDeleteCheckButton = styled.div`
		display: flex;
    align-items: center;
    height: 100%;
    width: 40px;
    cursor: pointer;
    &:hover {
      color: #fff;
      font-weight: 400;
      /* border-bottom: 1px solid #fff;    */
      text-decoration: underline;
    }
		/* &:nth-child(2) {
      padding: 0 8px 0 16px;
    }
    &:nth-child(3) {
      padding: 0 16px 0 8px;
    } */
`
export default connect(mapStateToProps)(InfoProposal);



// WEBPACK FOOTER //
// ./src/Info/InfoProposal.js